{
    "productClassList": [],
    "componentTypeList": [],
    "componentUnitList": [],
    "productClassComponentUnitList": [],
    "productClassComponentUnitPaging": {
        "offset": 50,
        "page": 1
    },
    "productClassComponentUnitTotalCount": 0,
    "productClassComponentUnitListSortExpression":null,
    "productClassComponentUnitListFilterExpression":null
}